/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum FreightClaimPaymentSource {
  Carrier = "carrier",
  Insurance = "insurance",
  Freightsimple = "freightsimple",
}

export function instanceOfFreightClaimPaymentSource(value: any): boolean {
  for (const key in FreightClaimPaymentSource) {
    if (Object.prototype.hasOwnProperty.call(FreightClaimPaymentSource, key)) {
      if (
        FreightClaimPaymentSource[
          key as keyof typeof FreightClaimPaymentSource
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function FreightClaimPaymentSourceFromJSON(
  json: any,
): FreightClaimPaymentSource {
  return FreightClaimPaymentSourceFromJSONTyped(json, false);
}

export function FreightClaimPaymentSourceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FreightClaimPaymentSource {
  return json as FreightClaimPaymentSource;
}

export function FreightClaimPaymentSourceToJSON(
  value?: FreightClaimPaymentSource | null,
): any {
  return value as any;
}

export function FreightClaimPaymentSourceToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): FreightClaimPaymentSource {
  return value as FreightClaimPaymentSource;
}
